import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Copy, QrCode, Trash, LinkSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

const CHANNELS = ["instagram", "facebook", "linkedin", "tiktok", "youtube", "email", "whatsapp", "google", "qr", "altro"];
const PAGES = [["/", "Home"], ["/blog", "Blog"], ["/auth", "Registrazione"], ["/compare", "Confronto"], ["/case-studies", "Case study"]];

async function copyText(t) {
  try { await navigator.clipboard.writeText(t); toast.success("Link copiato"); } catch { toast.error("Copia non riuscita"); }
}

function LinkRow({ lk, i, onDelete }) {
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=${encodeURIComponent(lk.url)}`;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 py-3 border-b border-line last:border-0" data-testid={`tracked-link-row-${i}`}>
      <div className="min-w-0 flex-1">
        <div className="text-sm text-ink font-medium">{lk.channel} · {lk.campaign} <span className="text-stone font-normal">→ {lk.page}</span></div>
        <div className="text-xs text-stone truncate">{lk.url}</div>
      </div>
      <div className="text-sm text-ink whitespace-nowrap" data-testid={`tracked-link-stats-${i}`}><b>{lk.visits}</b> visite · <b>{lk.signups}</b> registrazioni</div>
      <div className="flex gap-1">
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => copyText(lk.url)} data-testid={`tracked-link-copy-${i}`}><Copy size={14} /></Button>
        <a href={qr} target="_blank" rel="noreferrer"><Button size="sm" variant="outline" className="rounded-full" data-testid={`tracked-link-qr-${i}`}><QrCode size={14} /></Button></a>
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => onDelete(lk.id)} data-testid={`tracked-link-delete-${i}`}><Trash size={14} /></Button>
      </div>
    </div>
  );
}

export default function TrackedLinks() {
  const [links, setLinks] = useState([]);
  const [f, setF] = useState({ channel: "instagram", page: "/", campaign: "" });
  const load = () => api.get("/admin/links").then((r) => setLinks(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!f.campaign.trim()) return toast.error("Scrivi il nome della campagna");
    const r = await api.post("/admin/links", f);
    copyText(r.data.url);
    setF({ ...f, campaign: "" });
    load();
  };
  const del = async (id) => { await api.delete(`/admin/links/${id}`); load(); };

  return (
    <div className="rounded-2xl border border-line bg-canvas p-5" data-testid="tracked-links">
      <div className="font-serif text-lg text-ink mb-1 flex items-center gap-2"><LinkSimple size={18} />Link tracciati</div>
      <div className="text-sm text-stone mb-4">Crea un link per ogni bio, post, email o QR: vedrai quante visite e registrazioni porta.</div>
      <div className="grid md:grid-cols-4 gap-2">
        <Select value={f.channel} onValueChange={(v) => setF({ ...f, channel: v })}>
          <SelectTrigger data-testid="tracked-link-channel"><SelectValue /></SelectTrigger>
          <SelectContent>{CHANNELS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={f.page} onValueChange={(v) => setF({ ...f, page: v })}>
          <SelectTrigger data-testid="tracked-link-page"><SelectValue /></SelectTrigger>
          <SelectContent>{PAGES.map(([p, l]) => <SelectItem key={p} value={p}>{l} ({p})</SelectItem>)}</SelectContent>
        </Select>
        <Input placeholder="Nome campagna (es. bio-ottobre)" value={f.campaign} onChange={(e) => setF({ ...f, campaign: e.target.value })} data-testid="tracked-link-campaign" />
        <Button onClick={create} className="rounded-full bg-ink text-canvas hover:bg-olive" data-testid="tracked-link-create">Crea e copia</Button>
      </div>
      <div className="mt-4">
        {links.length ? links.map((lk, i) => <LinkRow key={lk.id} lk={lk} i={i} onDelete={del} />)
          : <div className="text-sm text-stone" data-testid="tracked-links-empty">Nessun link creato.</div>}
      </div>
    </div>
  );
}
